<template>
    <div class="bg-[#23242A]">
      <Nav :active="activeTab" :callback="changeActiveTab" @updateBalance="totalBalance = $event"/>
      <CashHistory :totalBalance="totalBalance" />
    </div>
</template>
  
  
  <script lang="ts">
  import {defineComponent, ref} from "vue"
  import { mapGetters, mapActions } from "vuex";
  import CashHistory from '@/views/CashMgmt/Vault/CashVault/CashHistory.vue';
  import CashVault from '@/views/CashMgmt/Vault/CashVault/CashVault.vue';
  import Nav from '@/views/CashMgmt/Vault/Nav.vue';

  
    export default defineComponent({
    name: "TransactionHistory",
    props: ['totalBalance'],
    components: {
      Nav,
      CashVault,
      CashHistory,
    },
  
    setup() {
      const totalBalance = ref(null)
      const activeTab = ref('transaction')
      return {
        activeTab,
        totalBalance
      };
    },
 
  
   
    methods: {
      
        changeActiveTab(data) {
        this.activeTab = data;
        },

  
      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    },
  });
  
  </script>